














































































import Vue from "vue";
import { AxiosResponse, AxiosError } from "axios";
export default Vue.extend({
  data() {
    return {
      uploadForm: {
        name: null,
        tags: null,
        description: null,
        text: null,
        origin: null,
        file: null
      }
    };
  },
  methods: {
    submitForm() {
      console.log("Form submitted");

      const formData = new FormData();

      formData.append("name", this.uploadForm.name || "");
      formData.append("tags", this.uploadForm.tags || "");
      formData.append("description", this.uploadForm.description || "");
      formData.append("text", this.uploadForm.text || "");
      formData.append("origin", this.uploadForm.origin || "");
      formData.append("newMeme", this.uploadForm.file || "");

      console.log(this.uploadForm);
      console.log(formData);

      this.axios
        .post("/api/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res: AxiosResponse) => {
          console.log(res);
        })
        .catch((err: AxiosError) => {
          console.log(err);
        });
    },
    handleFileUpload() {
      // eslint-disable-next-line
      this.uploadForm.file = (this.$refs.file as any).files[0];
    }
  }
});
